import { useEffect } from 'react';
import { authApiService } from '../api/auth.api';
import { authSession, useAuthStore } from '../stores/auth.store';

/**
 * Resolves the initial session exactly once on app start.
 *
 * The store rehydrates tokens synchronously from localStorage, but we still
 * need to confirm the session is live and (re)load the user profile. When this
 * finishes it flips `isInitialized`, which gates the router so we don't flash
 * the login screen for an already-authenticated user.
 */
export function useSessionBootstrap() {
  const setUser = useAuthStore((s) => s.setUser);
  const setInitialized = useAuthStore((s) => s.setInitialized);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      if (authSession.isAuthenticated()) {
        try {
          const user = await authApiService.me();
          if (!cancelled) setUser(user);
        } catch {
          // 401 here means the interceptor's refresh also failed → session gone.
          if (!cancelled) useAuthStore.getState().clear();
        }
      }
      if (!cancelled) setInitialized(true);
    })();

    return () => {
      cancelled = true;
    };
  }, [setUser, setInitialized]);
}
